<template>
  <v-dialog v-model="dialog" lazy width="854">
    <v-card>
      <v-toolbar dense color="primary" dark>
        <v-toolbar-title>
          {{
            country._id
              ? $t('titles.global.updateModel', {
                  field: $tc('models.country'),
                })
              : $t('titles.global.newModel', { field: $tc('models.country') })
          }}
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn dark icon @click="cancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex d-flex xs12 px-2>
            <translation-field
              ref="name"
              v-model="country.name"
              :label="$t('fields.global.name')"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-text-field
              v-model="country.iso"
              v-validate="'required'"
              :label="$t('fields.language.iso') + ' (*)'"
              :data-vv-name="$t('fields.language.iso')"
              :error-messages="errors.collect($t('fields.language.iso'))"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-text-field
              v-model="country.wtz"
              v-validate="'required'"
              :label="'WTZ (*)'"
              :data-vv-name="'WTZ'"
              :error-messages="errors.collect('WTZ')"
            />
          </v-flex>
          <v-flex md6 xs12 px-2>
            <v-switch
              v-model="country.active"
              :label="$t('fields.global.active')"
              color="primary"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <span style="color: red">(*) &nbsp;</span>
        <span>{{ $t('action.messages.fieldRequired') }}</span>
        <v-spacer />
        <meta-button type="reset" :disabled="loading" @click="clear" />
        <meta-button
          v-if="!country._id"
          type="create"
          :loading="loading"
          @click="submit()"
        />
        <meta-button
          v-else
          type="update"
          :loading="loading"
          @click="submit()"
        />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TranslationField from '@/components/widgets/Input/TranslationField'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'CountryForm',
  components: {
    TranslationField,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      country: {},
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
    selected: {
      handler: function (val) {
        if (val) this.country = parseObject(val)
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.country = parseObject(this.selected)
  },

  computed: {
    ...mapState({
      selected: (state) => state.countries.selected,
      loading: (state) => state.countries.loading,
    }),
  },
  methods: {
    ...mapActions({
      setCreate: 'countries/create',
      setUpdate: 'countries/update',
      reset: 'countries/reset',
    }),
    submit() {
      Promise.all([this.validate(), this.$refs.name.validate()]).then(
        (valid) => {
          if (valid.some((valid) => !valid)) return

          let payload = Object.assign({}, this.country)
          if (!payload._id) {
            this.setCreate(payload).then((_) => {
              this.cancel()
            })
          } else {
            this.setUpdate(payload).then((_) => {
              this.cancel()
            })
          }
        }
      )
    },
    cancel() {
      this.clear()
      this.$emit('close')
    },
    clear() {
      this.reset()
      this.$validator.reset()
    },
  },
}
</script>
